import { render, staticRenderFns } from "./DispatchTaskModal.vue?vue&type=template&id=63bb5520&scoped=true&lang=pug"
import script from "./DispatchTaskModal.vue?vue&type=script&lang=js"
export * from "./DispatchTaskModal.vue?vue&type=script&lang=js"
import style0 from "./DispatchTaskModal.vue?vue&type=style&index=0&id=63bb5520&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bb5520",
  null
  
)

export default component.exports